import { TravelRequestsQueryFilter } from 'api/travel-requests-list';
import { autoinject, BindingEngine, computedFrom, customElement } from 'aurelia-framework';
import { ApprovalStatus } from 'model/business-enums';
import { EnumsService } from 'services/enums-service';
import { ModelBase } from 'support/base_classes/model-base';
import { LISTS_DEBOUNCE } from 'support/settings';
import { MobileAppService } from 'services/mobile-app-service';

@autoinject
@customElement('requests-common-filter')
export class RequestsCommonFilterCustomElement extends ModelBase<TravelRequestsQueryFilter> {
  debounceMs = LISTS_DEBOUNCE;

  constructor(private enums: EnumsService, bindingEngine: BindingEngine, private mobileAppService: MobileAppService) {
    super(bindingEngine);
  }

  archiveOptions = [
    { value: false, name: 'Hide archived items' },
    { value: true, name: 'Show archived items' }
  ];

  @computedFrom('enums.approvalStatuses')
  get approvalStatuses() {
    return this.enums.approvalStatuses.map(i => ({ ...i, class: `at-approval-status --${ApprovalStatus[i.value].toLowerCase()}` }));
  }
}
